module.exports = __webpack_public_path__ + "static/media/reports-icon.d0822a5d.svg";